import React, { useEffect, useRef, useState } from 'react'
import './styles.scss'
// const scaleSteps = 250

import * as d3Scale from 'd3-scale'
import * as d3Selection from 'd3-selection'
import * as d3Array from 'd3-array'
import * as d3Multi from 'd3-selection-multi'
import * as d3Axis from 'd3-axis'
import * as d3TimeFormat from 'd3-time-format'
import * as d3Time from 'd3-time'
import * as d3Shape from 'd3-shape'
const d3 = {
  ...d3Scale,
  ...d3Selection,
  ...d3Array,
  ...d3Multi,
  ...d3Axis,
  ...d3TimeFormat,
  ...d3Time,
  ...d3Shape
}
const getMovingAverage = (data, count) => {
  const vals = []

  // if (count >= data.length) return

  for (let i = 0; i < count; i++) {
    if (data[data.length - (i + 1)]) vals.push(+data[data.length - (i + 1)].val)
  }

  const ave =
    vals.reduce((accumulator, currentValue) => accumulator + currentValue) /
    count
  return {
    y: +ave.toFixed(1),
    x: data[data.length - 1].date
  }
}
const movAverage = (data, count, prop) => {
  const values = []
  const aveData = []
  for (let j = 0; j < data.length; j++) {
    values.push({
      val: +data[j][prop],
      date: data[j].bydaydate
    })
    aveData.push(getMovingAverage(values, count))
  }
  return aveData
}
export const CaseChart = ({
  data,
  prop,
  scaleSteps,
  domain,
  showAverage,
  isMobile,
  vertflip,
  className
}) => {
  const svgRef = useRef(null)
  const [svgSize, setSvgSize] = useState<[number, number] | undefined>(
    undefined
  )
  const parseDate = (dateString: string) => {
    const dateParts = dateString.split('.')
    return new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0])
  }
  const padding = [vertflip ? 11 : 8, 10, 16, 10]

  useEffect(() => {
    if (!data || !svgSize) return
    const movingAverage = movAverage(data, 7, prop)

    const dateExtend = data.map(d => {
      return parseDate(d.bydaydate)
    })
    const tickDates = dateExtend.filter(function(value: Date, index: number) {
      if (isMobile) {
        return index % 14 === 0
      } else {
        return index % 10 === 0
      }
    })
    tickDates.pop()
    tickDates.push(new Date(dateExtend[dateExtend.length - 1]))
    /* eslint-disable */
    let line = d3
      .line<{ x: string; y: number }>()
      .x(d => padding[3] + x(parseDate(d.x).toString()) + x.bandwidth() / 2)
      .y(d => y(d.y) + padding[0])
      .curve(d3.curveLinear)
    /* eslint-enable */
    const svg = d3
      .select(svgRef.current)
      .html('')
      .attr('viewBox', '0 0 ' + svgSize[0] + ' ' + svgSize[1])

    const x = d3
      .scaleBand()
      .domain(dateExtend)
      .range([padding[3], svgSize[0] - padding[1] - padding[3]])
      .paddingInner(0.25)
    const xAxis = d3
      .axisBottom(x)
      .tickFormat(d3.timeFormat('%-d.%-m.%-Y'))
      .tickSizeOuter(0)
      .tickSize(0)
      .tickValues(tickDates.reverse())

    const y = d3
      .scaleLinear()
      .domain(vertflip ? [domain[1], domain[0]] : domain)
      .range([svgSize[1] - padding[0] - padding[2], padding[0]])
    const yAxis = d3
      .axisLeft(y)
      .tickSizeOuter(0)
      .tickSizeInner(-svgSize[0])
      .tickValues(
        d3.range(
          0,
          vertflip ? y.domain()[0] + scaleSteps : y.domain()[1] + scaleSteps,
          scaleSteps
        )
      )

    // if (!vertflip) {
    const xaxis = svg
      .append('g')
      .attr('class', 'xaxis')
      .attr(
        'transform',
        'translate(' +
          x(x.domain()[0]) +
          ',' +
          (vertflip ? 0 : svgSize[1] - padding[2]) +
          ')'
      )
      .call(xAxis)

    const xTicks = xaxis.selectAll('text')
    xTicks.attr('transform', 'translate(0,5)').each((d, e, f) => {
      const step = Math.ceil(svgSize[0] / (f.length * x.bandwidth()))
      if (e === 0) d3.select(f[e]).attr('text-anchor', 'end')
      if (e % step !== 0) d3.select(f[e]).remove()
    })
    xaxis.selectAll('.domain').remove()
    // }

    const yaxis = svg
      .append('g')
      .attr('class', 'yaxis')
      .attr('transform', 'translate(' + 3 + ',' + padding[0] + ')')
      .call(yAxis)

    yaxis.selectAll('.domain').remove()
    yaxis.selectAll('line').attr('stroke', '#ddd')
    yaxis
      .selectAll('text')
      .attr('transform', 'translate(0,-8)')
      .style('text-anchor', 'start')
      .style('fill', '#999BAA')

    svg
      .append('g')
      .attr('class', 'bars')
      .selectAll('rect')
      .data(data)
      .join('rect')
      .attrs({
        x: d => {
          return padding[3] + x(parseDate(d.bydaydate).toString())
        },
        y: d => {
          return vertflip ? y(0) + padding[0] : y(+d[prop]) + padding[0]
        },
        width: x.bandwidth(),
        height: d => {
          return vertflip
            ? y(+d[prop]) - padding[0]
            : y(y.domain()[0]) - y(+d[prop])
        },
        class: d => {
          return prop + ' ' + d.bydaydate
        },
        style: 'cursor:pointer'
      })
      .on('mouseover click', (d, e, f) => {
        const el = d3.select(
          f.filter(g => {
            if (g.classList.contains(d.bydaydate)) return f
          })[0]
        )

        el.attr('stroke', '#000')
        /* eslint-disable */
        tt.attr(
          'transform',
          'translate(' +
            (+el.attr('x') + x.bandwidth() / 2) +
            ',' +
            (vertflip
              ? +el.attr('y') + +el.attr('height')
              : +el.attr('y') - 25) +
            ')'
        )
        ttText.text(d[prop])
      })
      .on('mouseout', (d, e, f) => {
        let el = f.filter(g => {
          if (g.classList.contains(d.bydaydate)) return f
        })[0]
        d3.select(el).attr('stroke', 'none')
        tt.attr('transform', 'translate(-100,-100)')
      })
    /* eslint-enable */
    if (showAverage) {
      svg.append('path').attrs({
        d: line(movingAverage),
        class: 'movave ' + prop
      })
    }
    const tt = svg
      .append('g')
      .attr('transform', 'translate(-100,-100)')
      .attr('class', 'tt')
    const ttText = tt
      .append('text')
      .attrs({ x: 0, y: 18, 'text-anchor': 'middle', fill: '#999BAA' })
      .text('234')

    // const lastVal = data[data.length - 1]
    // if (lastVal[prop] > 0) {
    //   const lastValue = svg.append('g')
    //   lastValue
    //     .append('text')
    //     .attrs({
    //       x:
    //         padding[3] +
    //         x(parseDate(lastVal.bydaydate).toString()) +
    //         x.bandwidth(),
    //       y: vertflip ? y(+lastVal[prop]) + 40 : y(+lastVal[prop]) - 20,
    //       class: 'lastVal ' + prop,
    //       'text-anchor': 'end'
    //     })
    //     .text(lastVal[prop])
    //   lastValue.append('line').attrs({
    //     x1:
    //       padding[3] +
    //       x(parseDate(lastVal.bydaydate).toString()) +
    //       x.bandwidth() / 2,
    //     x2:
    //       padding[3] +
    //       x(parseDate(lastVal.bydaydate).toString()) +
    //       x.bandwidth() / 2,
    //     y1: vertflip ? y(+lastVal[prop]) + 20 : y(+lastVal[prop]) - 16,
    //     y2: y(+lastVal[prop]) + padding[0],
    //     class: 'lastValLine'
    //   })
    // }
  }, [data])
  useEffect(() => {
    if (svgRef && svgRef.current) {
      const width = svgRef.current.clientWidth || 400
      const height = svgRef.current.clientHeight || 200
      setSvgSize([width, height])
    }
  }, [svgRef.current])
  return <svg className={className} ref={svgRef} />
}
